(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		TitlePanel = include('PrimalSpringrollTemplate.TitlePanel');

	/**
	 * The logic for the title state
	 * @class PrimalSpringrollTemplate.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var TitleState = function(options)
	{
		BaseState.call(this, new TitlePanel(), options);

		this.onPlay = this.onPlay.bind(this);
	};

	// Extend the base class
	var p = extend(TitleState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		app.state = this;

		//Activate play button
		this.panel.playButton.addEventListener("click", this.onPlay);

	};

	//Start game when play button is clicked
	p.onPlay = function()
	{
		this.nextState();
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		// Release event listeners
		this.panel.playButton.off("click", this.onPlay);
	};

	//Assign to namespace
	namespace("PrimalSpringrollTemplate").TitleState = TitleState;
}());
